import React from 'react';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {
  grey100, grey400, grey500, white,
} from 'material-ui/styles/colors';
import spacing from 'material-ui/styles/spacing';
import PropTypes from 'prop-types';

const palette = {
  primary1Color: '#156f9d', // rgb(21, 111, 157)
  primary2Color: '#093043', // rgb(9, 48, 67)
  primary3Color: grey400,
  accent1Color: '#779c2b',
  accent2Color: grey100,
  accent3Color: grey500,
  textColor: '#444',
  secondaryTextColor: '#727272',
  alternateTextColor: white,
  canvasColor: white,
  borderColor: 'rgba(0, 0, 0, .12)',
  disabledColor: 'rgba(33, 33, 33, 0.3)',
  pickerHeaderColor: '#156f9d',
  clockCircleColor: 'rgba(33, 33, 33, 0.07)',
  shadowColor: 'rgba(0, 0, 0, .12)',
};

const theme = {
  spacing,
  fontFamily: 'Roboto, sans-serif',
  palette,
  textField: {
    hintColor: palette.secondaryTextColor,
  },
};
const muiTheme = getMuiTheme(theme);

export const ThemeProvider = ({ children }) =>
  <MuiThemeProvider muiTheme={muiTheme}>{children}</MuiThemeProvider>;

ThemeProvider.propTypes = {
  children: PropTypes.element,
};

export default muiTheme;



// WEBPACK FOOTER //
// ./src/styles/theme.js